


  <div mat-dialog-title>
    {{'Work Experience'| translate}}
    <span class="float-right pointer" (click)="close()">
      <i class="fa fa-times close-btn "></i>
    </span>
    <!-- <span style="float: right;" (click)="close()" ><mat-icon>close</mat-icon>  </span> -->
  
  
  </div>
  <div mat-dialog-content class="">
  
    <form [formGroup]="workExperienceForm">
      <div class="row">
        <div class="col-md-3" *ngIf=" field_config_access &&field_config_access['RES-Workexp_companyName']">
          <mat-form-field floatLabel='always'>
            <mat-label> {{field_config_access['RES-Workexp_companyName'].label ||'Employer/Project'}}
            </mat-label>
            <input matInput formControlName="companyName" required
              [placeholder]="field_config_access['RES-Workexp_companyName'].placeholder ||'Enter Employer/Project'">
            <mat-error
              *ngIf="workExperienceForm.controls.companyName.touched &&  workExperienceForm.controls.companyName.hasError('required')">
              {{'ERROR.field_is_mandatory'|translate}}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3" *ngIf=" id!=1 && field_config_access &&field_config_access['RES-Workexp_designationId']">
          <tm-select [auto_addition]="1" [auto_form_control]="'designationTitle'" [mandatory]="1"
            [auto_data]="workExperienceForm.value.designationTitle" [options]="this.jobseeker.jobTitleList"
            (selected_obj)="jobTitleChanged($event)" [master_obj]="jobseeker.jobTitleMasters" [enable_virtual_scroll]="1"
            (fetchEntries)="loadJobtitleList($event)" [label_action_title]="' not found? click here to add'"
            [label_action_type]="3" [design_pattern]="4" [form_group]="workExperienceForm" form_control="designationId"
            title_property="title" id_property="id" float_label="always"
            [label]="field_config_access['RES-Workexp_designationId'].label ||'Role' | translate"
            [data]="workExperienceForm.value.designationId"
            [placeholder]="field_config_access['RES-Workexp_designationId'].placeholder ||'RESUME.enterDesignation' | translate">
          </tm-select>
        </div>
        <div class="col-md-3" *ngIf=" field_config_access &&field_config_access['RES-Workexp_startDate']"
          [title]="'Date or MMM-YY'">
          <mat-form-field floatLabel='always'>
            <mat-label> {{field_config_access['RES-Workexp_startDate'].label ||'From'}} </mat-label>
            <input matInput required formControlName="startDate"
              [placeholder]="field_config_access['RES-Workexp_startDate'].placeholder ||'Date or MMM-YY'">
            <mat-error
              *ngIf="workExperienceForm.controls.startDate.touched &&  workExperienceForm.controls.startDate.hasError('required')">
              {{'ERROR.field_is_mandatory'|translate}}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3" *ngIf=" field_config_access &&field_config_access['RES-Workexp_endDate']"
          [title]="'Date or MMM-YY or Present'">
          <mat-form-field floatLabel='always'>
            <mat-label>{{ field_config_access['RES-Workexp_endDate'].label ||'To'}} </mat-label>
            <input matInput required formControlName="endDate"
              [placeholder]="field_config_access['RES-Workexp_endDate'].placeholder ||'Date or MMM-YY or Present'">
            <mat-error
              *ngIf="workExperienceForm.controls.endDate.touched &&  workExperienceForm.controls.endDate.hasError('required')">
              {{'ERROR.field_is_mandatory'|translate}}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6" *ngIf=" field_config_access &&field_config_access['RES-Workexp_ctcAmount']">
          <div class="prefix-control" style="width: 20%;">
            <tm-select [options]="master_data.currencyList||[]" [form_group]="workExperienceForm"
              form_control="ctcCurrencyId"
              [label]="  field_config_access['RES-Workexp_ctcAmount'].label ||'CTC' |translate"
              title_property="currencySymbol" id_property="currencyId" float_label="always"
              [data]="workExperienceForm.value.ctcCurrencyId" [placeholder]="'RESUME.currencyPlaceholder' | translate"
              [label_overflow]="1">
            </tm-select>
          </div>
          <div class="main-control" style="width: 30%;">
            <mat-form-field floatLabel="always">
              <mat-label></mat-label>
              <input matInput type="number" formControlName="ctcAmount"
                [placeholder]="field_config_access['RES-Workexp_ctcAmount'].placeholder ||'Enter amount'|translate">
            </mat-form-field>
          </div>
          <div class="suffix-control" style="width: 45%;">
            <tm-select [options]="master_data.scaleDurationList||[]" [form_group]="workExperienceForm"
              form_control="ctcscaleId" title_property="name" [label]="'Scale' | translate" id_property="scaleDurationId"
              float_label="always" [width]="152" [data]="workExperienceForm.value.ctcscaleId"
              [placeholder]="'RESUME.scalePlaceholder' | translate" [hide_label]="1">
            </tm-select>
          </div>
        </div>
        <div class="col-md-6" *ngIf=" field_config_access &&field_config_access['RES-Workexp_statusType']">
          <tm-select [options]="master_data.empHistoryStatusTypeList||[]" [form_group]="workExperienceForm"
            form_control="statusType"
            [label]=" field_config_access['RES-Workexp_statusType'].label || 'Status' |translate" title_property="title"
            id_property="id" float_label="always" [data]="workExperienceForm.value.statusType"
            [placeholder]=" field_config_access['RES-Workexp_statusType'].placeholder ||'<- -Select- ->' | translate"
            [label_overflow]="1">
          </tm-select>
        </div>
        <div class="col-md-4" *ngIf=" field_config_access &&field_config_access['RES-Workexp_attachments']">
          <tm-files-v2 [form_group]="workExperienceForm" [form_control]="'attachments'"
            (validStatus)="uploadedStatus($event)"
            [label]="field_config_access['RES-Workexp_attachments'].label ||'Attachments'|translate"
            [result]="workExperienceForm.value.attachments"></tm-files-v2>
        </div>
        <div class="col-md-6" *ngIf=" field_config_access &&field_config_access['RES-Workexp_notes']">
          <mat-form-field floatLabel="always">
            <mat-label>{{field_config_access['RES-Workexp_notes'].label ||'Notes'}}</mat-label>
            <input matInput formControlName="notes"
              [placeholder]="field_config_access['RES-Workexp_notes'].placeholder||'Enter notes'|translate">
          </mat-form-field>
        </div>
        <div class="col-md-2 text-right " *ngIf="id!=1">
          <button (click)="addExperience()" class="btn btn-sm mat-mt js-btn-save">
            <i class="fa fa-plus-square mx-1"></i>
            {{'BTN.add'|translate}}
          </button>
        </div>
  
        <div *ngIf="id!=1" class="col-md-12 table-responsive tm-data-table  "
          style="height: calc(100vh - 400px);overflow: auto;">
          <table class="table table-striped" *ngIf="field_config_access">
            <thead>
              <tr>
                <th *ngIf="field_config_access['RES-Workexp_companyName']">
                  {{
                  field_config_access['RES-Workexp_companyName'].label ||'Employer/Project'}}
                </th>
                <th *ngIf="field_config_access['RES-Workexp_designationId']">
                  {{
                  field_config_access['RES-Workexp_designationId'].label ||'Role' | translate}}
                </th>
                <th *ngIf="field_config_access['RES-Workexp_startDate']">
                  {{field_config_access['RES-Workexp_startDate'].label ||'From'}}
                </th>
                <th *ngIf=" field_config_access['RES-Workexp_endDate']">
                  {{
                  field_config_access['RES-Workexp_endDate'].label ||'To'}}
                </th>
                <th *ngIf="field_config_access['RES-Workexp_ctcAmount']">
                  {{
                  field_config_access['RES-Workexp_ctcAmount'].label ||'CTC' |translate}}
                </th>
                <th *ngIf="field_config_access['RES-Workexp_statusType']">
                  {{
                  field_config_access['RES-Workexp_statusType'].label || 'Status' |translate}}
                </th>
                <th *ngIf="field_config_access['RES-Workexp_attachments']">
                  {{
                  field_config_access['RES-Workexp_attachments'].label ||'Attachments'|translate}}
                </th>
                <th *ngIf="field_config_access['RES-Workexp_notes']">
                  {{
                  field_config_access['RES-Workexp_notes'].label ||'Notes'}}
                </th>
                <th>
                  Action
                </th>
              </tr>
  
            </thead>
            <tbody>
              <tr *ngFor="let item of exp_list;let i = index">
                <td *ngIf="field_config_access['RES-Workexp_companyName']"> {{item.companyName}} </td>
                <td *ngIf="field_config_access['RES-Workexp_designationId']"> {{ item.designationTitle }} </td>
                <td *ngIf="field_config_access['RES-Workexp_startDate']"> {{item.startDate}} </td>
                <td *ngIf=" field_config_access['RES-Workexp_endDate']"> {{item.endDate}} </td>
                <td *ngIf="field_config_access['RES-Workexp_ctcAmount']"> {{item.ctcCurrencyId | DynamicPipe
                  : master_data['currencyList']
                  :'currencyId':'currencySymbol'}} {{item.ctcAmount}} {{item.ctcscaleId | DynamicPipe :
                  master_data['scaleDurationList']
                  :'scaleDurationId':'name'}} </td>
                <td *ngIf="field_config_access['RES-Workexp_statusType']">
                  {{item.statusType |DynamicPipe : master_data['empHistoryStatusTypeList']:'id':'title' }}
                </td>
  
                <td *ngIf="field_config_access['RES-Workexp_attachments']" class="link"
                  (click)="viewAttachments(item.attachments)"> {{item.attachments &&
                  item.attachments.length?'View':''}} </td>
                <td *ngIf="field_config_access['RES-Workexp_notes']">
                  {{item.notes}}
                </td>
                <td>
                  <button class="btn btn-sm btn-default mx-1 " (click)="editExperience(i)">
                    <i class="fa fa-pencil mx-1"></i>
                    {{'BTN.edit'|translate}}
                  </button>
                  <button class="btn btn-sm btn-default mx-1 " (click)="deleteExperience(i)">
                    <i class="fa fa-trash orange mx-1"></i>
                    {{'BTN.delete'|translate}}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="id==1" class="col-md-12 table-responsive tm-data-table  "
          style="height: calc(100vh - 400px);overflow: auto;">
          <table class="table table-striped" *ngIf="field_config_access">
            <thead>
              <tr>
                <th *ngIf="field_config_access['RES-Workexp_companyName']">
                  {{
                  field_config_access['RES-Workexp_companyName'].label ||'Employer/Project'}}
                </th>
                <th *ngIf="field_config_access['RES-Workexp_designationId']">
                  {{
                  field_config_access['RES-Workexp_designationId'].label ||'Role' | translate}}
                </th>
                <th *ngIf="field_config_access['RES-Workexp_startDate']">
                  {{field_config_access['RES-Workexp_startDate'].label ||'From'}}
                </th>
                <th *ngIf=" field_config_access['RES-Workexp_endDate']">
                  {{
                  field_config_access['RES-Workexp_endDate'].label ||'To'}}
                </th>
                <th *ngIf="field_config_access['RES-Workexp_ctcAmount']">
                  {{
                  field_config_access['RES-Workexp_ctcAmount'].label ||'CTC' |translate}}
                </th>
                <th *ngIf="field_config_access['RES-Workexp_statusType']">
                  {{
                  field_config_access['RES-Workexp_statusType'].label || 'Status' |translate}}
                </th>
                <th *ngIf="field_config_access['RES-Workexp_attachments']">
                  {{
                  field_config_access['RES-Workexp_attachments'].label ||'Attachments'|translate}}
                </th>
                <th *ngIf="field_config_access['RES-Workexp_notes']">
                  {{
                  field_config_access['RES-Workexp_notes'].label ||'Notes'}}
                </th>
                <!-- <th>
                  Action
                </th> -->
              </tr>
  
            </thead>
            <tbody>
              <tr *ngFor="let item of exp_list;let i = index">
                <td *ngIf="field_config_access['RES-Workexp_companyName']"> {{item.companyName}} </td>
                <td *ngIf="field_config_access['RES-Workexp_designationId']"> {{item.designationId &&
                  item.designationId>0? (
                  item.designationId |DynamicPipe
                  :master_data['jobTitleList']:'id':'title' ): item.designationTitle }} </td>
                <td *ngIf="field_config_access['RES-Workexp_startDate']"> {{item.startDate}} </td>
                <td *ngIf=" field_config_access['RES-Workexp_endDate']"> {{item.endDate}} </td>
                <td *ngIf="field_config_access['RES-Workexp_ctcAmount']"> {{item.ctcCurrencyId | DynamicPipe
                  : master_data['currencyList']
                  :'currencyId':'currencySymbol'}} {{item.ctcAmount}} {{item.ctcscaleId | DynamicPipe :
                  master_data['scaleDurationList']
                  :'scaleDurationId':'name'}} </td>
                <td *ngIf="field_config_access['RES-Workexp_statusType']">
                  {{item.statusType |DynamicPipe : master_data['empHistoryStatusTypeList']:'id':'title' }}
                </td>
  
                <td *ngIf="field_config_access['RES-Workexp_attachments']" class="link"
                  (click)="viewAttachments(item.attachments)"> {{item.attachments &&
                  item.attachments.length?'View':''}} </td>
                <td *ngIf="field_config_access['RES-Workexp_notes']">
                  {{item.notes}}
                </td>
                <!-- <td>
                  <button class="btn btn-sm btn-default mx-1 " (click)="editExperience(i)">
                    <i class="fa fa-pencil mx-1"></i>
                    {{'BTN.edit'|translate}}
                  </button>
                  <button class="btn btn-sm btn-default mx-1 " (click)="deleteExperience(i)">
                    <i class="fa fa-trash orange mx-1"></i>
                    {{'BTN.delete'|translate}}
                  </button>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </form>
  </div>
  <mat-dialog-actions *ngIf="id!=1">
    <span style="font-size: 13px !important;" id="tm-popup-notification-window"> </span>
  
    <button style="min-width: 100px;" class="ml-auto  blob-btn-cancel btn mx-1 mx-1 tallite-action" (click)="close()">
      {{ 'BTN.cancel' | translate}}
      <span class="blob-btn-cancel__inner">
        <span class="blob-btn-cancel__blobs">
          <span class="blob-btn-cancel__blob"></span>
          <span class="blob-btn-cancel__blob"></span>
          <span class="blob-btn-cancel__blob"></span>
          <span class="blob-btn-cancel__blob"></span>
        </span>
      </span>
    </button>
    <button style="min-width: 100px;" class="blob-btn  btn   mx-1 tallite-action" type="submit" (click)="save()">
      {{ 'BTN.ok' | translate }}
      <span class="blob-btn__inner">
        <span class="blob-btn__blobs">
          <span class="blob-btn__blob"></span>
          <span class="blob-btn__blob"></span>
          <span class="blob-btn__blob"></span>
          <span class="blob-btn__blob"></span>
        </span>
      </span>
    </button>
  </mat-dialog-actions>